import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Accueil from './pages/Accueil';
import LeCabinet from './pages/LeCabinet';
import NosAvocats from './pages/NosAvocats';
import DomainesIntervention from './pages/DomainesIntervention';
import Contact from './pages/Contact';
import './App.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Accueil />} />
            <Route path="/le-cabinet" element={<LeCabinet />} />
            <Route path="/nos-avocats" element={<NosAvocats />} />
            <Route path="/domaines-intervention" element={<DomainesIntervention />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
